import type { PaginationState } from '@tanstack/react-table';
import { useEffect, useRef } from 'react';
import { useDebounce } from 'use-debounce';
import { DEFAULT_PAGE_INDEX } from '../lib';

export function useDebouncedSearch(
  value: string | null | undefined,
  delay: number,
  setPagination: React.Dispatch<React.SetStateAction<PaginationState>>
): string {
  const [debouncedValue] = useDebounce(value ?? '', delay);
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Skip reset on first render to avoid unnecessary state update
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setPagination((prev) => ({ ...prev, pageIndex: DEFAULT_PAGE_INDEX }));
  }, [debouncedValue, setPagination]);

  return debouncedValue;
}
